<template>
	<div class="panel-body no-padding">
		<div class="table-responsive no-overflow">
			<table-editable-list :columns="columns"
														:show-select="true"
														:show-actions="selectedCourseForm.USE_ALTERNATES_FLG === 'Y'"
														:tableClass="{'margin-bottom-0': true, 'no-border': true}">
				<template slot="select">
					<th>{{ $t('MAIN_CONTENT.CourseRequestForms.actions') }}</th>
				</template>
				<template slot="actions" v-if="selectedCourseForm.USE_ALTERNATES_FLG === 'Y'">
					<th>{{ $t('MAIN_CONTENT.Elective.alternate') }}</th>
				</template>
				<template slot="data-row">
					<template v-for="(course, idx) in department.COURSES">
						<table-list-row :key="`course_${course.COURSE_ID}_${idx}`"
														:columns="columns"
														:rowdata="course"
														:rowIndex="idx"
														:showActions="selectedCourseForm.USE_ALTERNATES_FLG === 'Y'"
														:customTRClasses="getClasses(course)">
							<template slot="select">
								<td class="toggle-fixed-width">
									<sapphire-toggle :disabled="isToggleDisabled(course)"
																		v-model="course.IS_SELECTED"
																		@input="$emit('dataChanged', 'elective', department, course)">
									</sapphire-toggle>
								</td>
							</template>

							<template slot="courseTitle">
								<td>
									{{ course.DISPLAY_TITLE }}
									<template v-if="!!course.COURSE_CATALOG_DESC">
										<font-awesome-icon icon="question-circle"
																				v-tooltip.right="{trigger: 'hover click', content: course.COURSE_CATALOG_DESC}"
																				style="cursor: pointer;">
										</font-awesome-icon>
									</template>
									<p v-if="getClasses(course)['required-prereq']" style='color:red'>
										{{ getCoursePreAssignedMessage(course) }}
									</p>
									<p v-if="getClasses(course)['failed-prereq']" style='color:red'>
										{{ $t('MAIN_CONTENT.CourseRequestForms.failedPrerequisites') }}
									</p>
									<p v-if="getClasses(course)['course-taken']" style='color:red'>
										{{ $t('MAIN_CONTENT.CourseRequestForms.courseNonRepeat') }}
									</p>
								</td>
							</template>
							<template slot="credits">
								<td class="credits-fixed-width">{{course.CREDITS}}</td>
							</template>
							<template slot="actions" v-if="selectedCourseForm.USE_ALTERNATES_FLG === 'Y'">
								<sapphire-toggle :disabled="(course.IS_SELECTABLE === 'N' || course.IS_SELECTED === 'Y') && !(course.IS_SELECTED === 'Y' && course.IS_ALTERNATE_SELECTED === 'Y')"
																 v-model="course.IS_ALTERNATE_SELECTED"
																 @input="$emit('dataChanged', 'elective', department, course)">
								</sapphire-toggle>
							</template>
						</table-list-row>
					</template>
				</template>
				<template slot="append-list" v-if="selectedCourseForm.SPECIAL_REQUEST_USE_FLG === 'B' || selectedCourseForm.SPECIAL_REQUEST_USE_FLG === 'E'">
					<tr>
						<td>
							<sapphire-toggle v-model="department.SPECIAL_REQUEST.IS_SELECTED"
															 @input="$emit('dataChanged', 'special', department, {})">
							</sapphire-toggle>
						</td>
						<td colspan="3" >
							<strong v-if="!selectedCourseForm.SPECIAL_REQUEST_LABEL">
								{{ $t('MAIN_CONTENT.CourseRequestForms.specialRequestNotes') }}
							</strong>
							<strong v-html="selectedCourseForm.SPECIAL_REQUEST_LABEL" />
							<span style="color: red;" v-if="!selectedCourseForm.SPECIAL_REQUEST_DESC">
								{{ $t('MAIN_CONTENT.CourseRequestForms.chooseDesiredCourseInParenthese') }}
							</span>
							<span style="color: red;" v-html="selectedCourseForm.SPECIAL_REQUEST_DESC"/>
							<template v-if="department.SPECIAL_REQUEST.IS_SELECTED === 'Y' && selectedCourseForm.SPECIAL_REQUEST_NOTES_FLG === 'Y'">
								<br />
								<label :for="`course_${department.DEPARTMENT_ID}_special`" style="font-weight: normal;">
									{{ $t('MAIN_CONTENT.CourseRequestForms.moreDetailWithColon') }} 
								</label>
								<input type="text"
											 :name="`course_${department.DEPARTMENT_ID}_special`"
											 :id="`course_${department.DEPARTMENT_ID}_special`"
											 class="form-control"
											 v-model="department.SPECIAL_REQUEST.SR_NOTES"
											 @input="$emit('dataChanged', 'special', department, {})" />
							</template>
						</td>
					</tr>
				</template>
			</table-editable-list>
		</div>
	</div>
</template>

<script>
	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		name: 'Elective',
		data() {
			return {
				isDeselectable : !!this.selectedCourseForm.OVERRIDE_ELEC_RECOMMENDATIONS_FLG && this.selectedCourseForm.OVERRIDE_ELEC_RECOMMENDATIONS_FLG === 'Y'
			}
		},
		props: {
			department: {
				type:			Object,
				required:	true
			},
			selectedCourseForm:{
				type:			Object,
				required:	true
			}
		},
		computed: {
			columns() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.CourseRequestForms.courseTitle' ),
						key: 'DISPLAY_TITLE',
						customCol: 'courseTitle'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.CourseRequestForms.credits' ),
						key: 'CREDITS',
						customCol: 'credits'
					}
				];
			}
		},
		components: {
			SapphireToggle,
			TableEditableList,
			TableListRow
		},
		methods: {
			isToggleDisabled(course){

				if( course.IS_ALTERNATE_SELECTED === 'Y' ){
					return true;
				}

				// If student fails prereq for course and it is selected. Allow it to be deselected.
				const isFailedPrereqDeselectable = course.LINE_TYPE === 'FAILED_PREREQ' && course.IS_SELECTABLE === 'N' && course.IS_SELECTED === 'Y';
				if( isFailedPrereqDeselectable ){
					return false;
				}

				const isElectiveOverridable = course.LINE_TYPE === 'SIS_REQ' && this.selectedCourseForm.OVERRIDE_ELEC_RECOMMENDATIONS_FLG === 'Y' && course.COURSE_TYPE === 'E';
				if( isElectiveOverridable ){
					return false;
				}

				return course.IS_SELECTABLE === 'N';
			},
			getCoursePreAssignedMessage(course){

				if( course.LINE_TYPE === 'SIS_REQ' && this.isDeselectable ){
					return this.$t('MAIN_CONTENT.CourseRequestForms.courseAdminPreAssignedDeselectable');
				}
				
				if( course.LINE_TYPE === 'SIS_REQ' ) {
					return this.$t('MAIN_CONTENT.CourseRequestForms.courseAdminPreAssigned');
				}

				if( this.isDeselectable ){
					return this.$t('MAIN_CONTENT.CourseRequestForms.coursePreAssignedDeselectable');
				}
				else{
					return this.$t('MAIN_CONTENT.CourseRequestForms.coursePreAssigned');
				}
				
			},
			getClasses(course) {
				let newObj = {'required-prereq': false, 'failed-prereq': false};
				switch(course.LINE_TYPE) {
					case 'SIS_REQ':
						newObj['required-prereq'] = true; // green
						break;
					case 'SIS_STUD_REC':
						newObj['required-prereq'] = true; // green
						break;
					case 'FAILED_PREREQ':
						newObj['failed-prereq'] = true; // red
						break;
					case 'REPEAT_COURSE':
						newObj['course-taken'] = true; // red
						break;
					case 'CWP_STUD_REQ':
						break;
					case 'SIS_STUD_REQ':
						break;
					default: // NORMAL and etc. no color change
						break;
				}

				return newObj;
			}
		}
	}
</script>

<style scoped>
	.toggle-fixed-width {
		width: 70px;
	}
	.credits-fixed-width {
		width: 100px;
	}
</style>
